import { render } from "./IconCorner.vue?vue&type=template&id=6c85d30e&ts=true"
import script from "./IconCorner.vue?vue&type=script&lang=ts"
export * from "./IconCorner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__